import { NavItemsSimple } from '@/components/custom/nav-Items-simple'
import { useAuth } from '@/features/auth'
import { useSceneStore } from '@/features/shared/stores/scene.store'
import { useWorkspace, WorkspaceSidebarScaffold } from '@/features/workspace'
import { downloadScriptWithFirebase, syncScriptWithFirebase } from '@/service/firestore'
import { Sidebar } from '@/shared/components/ui/sidebar'
import { $getNodeByKey, $getRoot, LexicalNode } from 'lexical'
import React from 'react'
import { BaseNode } from './nodes/BaseNode'
import { NodeType } from './nodes/NodeCore'
import { PageBreakNode } from './nodes/PageBreakNode'
import { data } from './scripts/data'
import { setJsonScriptEditor } from './utils/JsonUtils'
import { handleDownload } from './utils/utils'
const usablePageHeight = 9 * 96 //total - 1056, - (2x 1 in *96)
const pageWidth = 816
export function SpEditorSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
    const { project } = useWorkspace()
    const { editor } = useSceneStore()
    const { user } = useAuth()

    const subMenuData = [
        {
            name: 'Paginate',
            emoji: 'pg',
            onClick: () => {
                editor?.update(() => {
                    const root = $getRoot()
                    const children = root.getChildren()
                    //Remove all page breaks
                    children.forEach((node: LexicalNode) => {
                        console.log('>', node)
                        if (node.getType() === NodeType.PageBreak) {
                            node.remove()
                        }
                    })

                    const root1 = $getRoot()
                    const children1 = root1.getChildren()
                    let currentPageHeight = 0
                    const nodesToBreak: string[] = []
                    for (let i = 0; i < children1.length; i++) {
                        const node = children1[i]
                        const nodeKey = node.getKey()
                        const dom = editor.getElementByKey(nodeKey)
                        if (!dom) continue
                        const rect = dom.getBoundingClientRect()
                        const nodeHeight = rect.height

                        if (
                            currentPageHeight + nodeHeight > usablePageHeight &&
                            currentPageHeight > 0
                        ) {
                            nodesToBreak.push(nodeKey)
                            currentPageHeight = nodeHeight
                        } else {
                            currentPageHeight += nodeHeight
                        }
                    }
                    console.log(nodesToBreak)
                    nodesToBreak.forEach((nodeKey: string) => {
                        const node = $getNodeByKey(nodeKey)
                        if (node) {
                            node.insertBefore(BaseNode.create(PageBreakNode))
                        }
                    })
                })
            },
        },
        {
            name: 'Download PDF',
            emoji: '📄', // Document
            onClick: () => handleDownload(project!.title),
        },
        {
            name: 'Load Json',
            emoji: '📥', // Inbox tray (download)
            onClick: async () => {
                setJsonScriptEditor(editor, data)
            },
        },
        {
            name: 'Sync Script Down',
            emoji: '🔄', // Sync icon
            onClick: async () => {
                const data = await downloadScriptWithFirebase()
                setJsonScriptEditor(editor, data?.content ?? [])
            },
        },
        {
            name: 'Upload to Database',
            emoji: '📤', // Outbox tray (upload)
            onClick: async () => {
                syncScriptWithFirebase(user!.uid, project!.id)
            },
        },
    ]

    return (
        <WorkspaceSidebarScaffold>
            {subMenuData.length !== 0 && (
                <NavItemsSimple navItems={subMenuData} header={{ title: 'Options' }} />
            )}
        </WorkspaceSidebarScaffold>
    )
}

export default SpEditorSidebar
